import React, { useState } from 'react';
import AdSpacePurchasePlansAdminList from './components/PurchasePlansAdminList';
import AdSpacePurchasePlansAdminAddPurchasePlanPage from './components/PurchasePlansAdminAddPurchasePlanPage';
import { Box, Tabs, Tab } from '@mui/material';



const AdSpacePurchasePlansAdminPage: React.FC = () => {
  const [tab, setTab] = useState(0);

  const handleTabChange = (_: React.SyntheticEvent, newValue: number) => {
    setTab(newValue);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Tabs value={tab} onChange={handleTabChange} aria-label="AdSpaces admin tabs">
        <Tab label="List Purchase Plans" />
        <Tab label="Insert Purchase Plan" />
      </Tabs>
      <Box sx={{ mt: 2 }}>
        {tab === 0 && <AdSpacePurchasePlansAdminList />}
        {tab === 1 && <AdSpacePurchasePlansAdminAddPurchasePlanPage />}
      </Box>
    </Box>
  );
};

export default AdSpacePurchasePlansAdminPage;